import { AuthenticateResultModel } from './AuthenticateResultModel';
import { ExternalAuthenticateResultModel } from './ExternalAuthenticateResultModel';
import { ExternalLoginProviderInfoModel } from './ExternalLoginProviderInfoModel';
import { throwException } from './Utilities';
var TokenAuthServiceProxy = /** @class */ (function () {
    function TokenAuthServiceProxy(baseUrl) {
        this.beforeSend = undefined;
        this.jsonParseReviver = undefined;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.authenticate = function (model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.authenticateWithCallbacks(model, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    TokenAuthServiceProxy.prototype.authenticateWithCallbacks = function (model, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        abp.ajax.request({
            url: url_,
            method: "post",
            data: content_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processAuthenticateWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processAuthenticateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    TokenAuthServiceProxy.prototype.processAuthenticateWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processAuthenticate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    TokenAuthServiceProxy.prototype.processAuthenticate = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    /**
     * @param model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.externalAuthenticateWithCode = function (model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.externalAuthenticateWithCodeWithCallbacks(model, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    TokenAuthServiceProxy.prototype.externalAuthenticateWithCodeWithCallbacks = function (model, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticateWithCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        abp.ajax.request({
            url: url_,
            method: "post",
            data: content_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processExternalAuthenticateWithCodeWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processExternalAuthenticateWithCodeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticateWithCodeWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processExternalAuthenticateWithCode(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticateWithCode = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.getExternalAuthenticationProviders = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.getExternalAuthenticationProvidersWithCallbacks(function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    TokenAuthServiceProxy.prototype.getExternalAuthenticationProvidersWithCallbacks = function (onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");
        abp.ajax.request({
            url: url_,
            method: "get",
            headers: {
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processGetExternalAuthenticationProvidersWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processGetExternalAuthenticationProvidersWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    TokenAuthServiceProxy.prototype.processGetExternalAuthenticationProvidersWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processGetExternalAuthenticationProviders(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    TokenAuthServiceProxy.prototype.processGetExternalAuthenticationProviders = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                    var item = resultData200_1[_i];
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                }
            }
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    /**
     * @param model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.externalAuthenticate = function (model) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.externalAuthenticateWithCallbacks(model, function (result) { return resolve(result); }, function (exception, _reason) { return reject(exception); });
        });
    };
    TokenAuthServiceProxy.prototype.externalAuthenticateWithCallbacks = function (model, onSuccess, onFail) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        abp.ajax.request({
            url: url_,
            method: "post",
            data: content_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        }).then(function (xhr) {
            _this.processExternalAuthenticateWithCallbacks(url_, xhr, onSuccess, onFail);
        }, function (xhr) {
            xhr = xhr.response;
            _this.processExternalAuthenticateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticateWithCallbacks = function (_url, xhr, onSuccess, onFail) {
        try {
            var result = this.processExternalAuthenticate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        }
        catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticate = function (xhr) {
        var status = xhr.status;
        var _headers = {};
        if (status === 200) {
            var _responseText = xhr.responseText;
            var result200 = null;
            var resultData200 = (_responseText === "" || _responseText === undefined) ? (xhr.data === null ? null : xhr.data.result) : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return result200;
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = xhr.responseText;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, xhr.data);
        }
        return null;
    };
    return TokenAuthServiceProxy;
}());
export { TokenAuthServiceProxy };
